var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.262 9.63079V2.52081H20.2064V4.58521L17.2188 1.60349C16.2997 0.686205 14.8442 0.686205 14.0014 1.60349L1.28479 14.2182C0.90165 14.6006 0.671875 15.1355 0.671875 15.7471C0.671875 16.2826 0.90165 16.8937 1.28479 17.2761C1.66792 17.6584 2.20388 17.8878 2.81675 17.8878C3.35325 17.8878 3.96561 17.6585 4.34872 17.2761L5.95771 15.6703V24.9977H14.0777V18.7282L17.1417 18.7287V24.9982H25.3387V15.6703L26.9477 17.2761C27.3308 17.6585 27.8668 17.8878 28.4797 17.8878C29.0162 17.8878 29.6285 17.6585 30.0116 17.2761C30.3947 16.8937 30.6245 16.3588 30.6245 15.7471C30.6245 15.1355 30.3948 14.6005 30.0116 14.2182L25.262 9.63079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.740fc6db1f136714fc2972703c37437d.svg";
export { ForwardRef as ReactComponent };